import React from "react";
import { v4 as uuidv4 } from "uuid";
import Button from "@mui/material/Button";
import { Paper } from "@mui/material";
import cloud from "../../assets/db_images/cloud-data.png";
import legacy from "../../assets/db_images/legacy.png";
import cross from "../../assets/db_images/cross-platform.png";
import scla from "../../assets/cloud_migration/scalability.png";
import security from "../../assets/cloud_migration/security.png";

const CloudConsultationService = () => {
  let featureList = [
    {
      id: uuidv4(),
      title: "Strategic Vision",
      image: cloud,
      description: `The strategic vision of Cloud Consulting involves aligning cloud
            adoption with the broader goals of an organization, emphasizing
            agility, innovation, and cost-effectiveness. It encompasses designing
            scalable and secure cloud architectures, optimizing resource
            utilization, and fostering a culture of continuous improvement.
            Strategic cloud consulting aims to leverage cloud technologies to
            enhance operational efficiency, mitigate risks, and contribute to
            overall business success. It involves informed decision-making,
            proactive cost management, and the development of in-house expertise,
            ensuring that cloud solutions not only meet current needs but also
            support long-term growth and adaptability.`,
    },
    {
      id: uuidv4(),
      title: "Tailored solutions",
      image: legacy,
      description: `Tailored solutions in Cloud Consulting involve customizing cloud
            strategies to precisely fit the unique needs and objectives of a
            specific organization. This approach recognizes that a
            one-size-fits-all solution may not be optimal for every business.
            Cloud consultants analyze the specific requirements, challenges, and
            goals of the client and design a bespoke plan that leverages cloud
            technologies to address those distinct factors. Designing cloud
            architectures that align with the organization's specific workflows,
            scalability requirements, and security considerations.`,
    },
    {
      id: uuidv4(),
      title: "Seamless migration",
      image: cross,
      description: `Seamless migration in Cloud Consulting involves the smooth and
            efficient transition of an organization's digital assets,
            applications, and data from existing infrastructure to a cloud
            environment. The goal is to minimize disruptions to operations,
            ensuring continuity and optimal performance throughout the migration
            process. Developing a detailed migration plan that considers specific
            business needs and objectives. Adopting an incremental or phased
            migration strategy to minimize the impact on day-to-day operations.
            Ensuring the integrity and security of data during the migration
            process.`,
    },
    {
      id: uuidv4(),
      title: "Security at the Core",
      image: security,
      description: `Security at the core of Cloud Consulting involves prioritizing robust
            measures to safeguard data, applications, and infrastructure in cloud
            environments. This approach recognizes the critical importance of
            security in the digital landscape and integrates it as a foundational
            element throughout the entire cloud journey. Conducting thorough risk
            assessments to identify potential vulnerabilities and threats.
            Ensuring adherence to industry regulations and compliance standards
            relevant to the organization. Implementing strong IAM policies to
            control and monitor user access to cloud resources. Utilizing
            multi-factor authentication and least privilege principles to enhance
            security.
            `,
    },
    {
      id: uuidv4(),
      title: "Optimizing the investment ",
      image: scla,
      description: `Optimizing the investment in Cloud Consulting involves strategically
              managing resources, maximizing cost-effectiveness, and ensuring that
              the benefits of cloud technologies align with the organization's
              goals. This approach focuses on extracting the highest value from
              cloud services while controlling and optimizing associated
              costs.Conducting a comprehensive analysis of current and projected
              cloud usage costs.Developing a cost optimization plan that aligns with
              the organization's budgetary constraints and objectives.
              `,
    },
  ];

  return (
    <div id="solutions">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold text-[#333e49]">
        Services we Provide
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 grid-rows-2 px-3 sm:px-20 mt-10 gap-3 flex-col sm:flex-row sm:flex-wrap">
        {featureList.map((item) => (
          <div
            key={item.id}
            class="w-full bg-gradient-to-l from-slate-300 to-slate-100 text-slate-600 border border-slate-300 grid grid-col-2 justify-center p-4 gap-4 rounded-lg shadow-md"
          >
            <div class="col-span-2 text-lg font-bold capitalize rounded-md text-[#00756a] italic">
              {item.title}
            </div>
            <div class="col-span-2 rounded-md">{item.description}</div>
            <div>
              <Button variant="outlined" href="#contact">
                Let's Connect
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CloudConsultationService;
